import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from "react-router-dom"; //make sure to import all the components.
import Translated from "../../../components/Translated/Translated";

export class ProductGroupTableRow extends Component {
    render() {
        return (
            <React.Fragment>
                <tr class="project-search-table-row">
                    <th id="tbody-header" scope="row">
                        {this.props.index}
                    </th>
                    <td>{this.props.groupName}</td>
                    <NavLink

                        to={"/settings/product-groups/edit?productGroupId=" + this.props.productGroupId + "&groupName=" + this.props.groupName}
                    >
                        <td><Translated section="Misc" label="edit_label" /></td>
                    </NavLink>
                </tr>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ProductGroupTableRow)
